import Swiper, { Thumbs } from 'swiper';
Swiper.use([Thumbs]);

window.Swiper = Swiper;
